module.exports = __webpack_public_path__ + "static/media/icons8-medium-new.754a004d.svg";